import View from '~/app/View'
import SmsLanding from '~/components/sms/sms-landing'

const smslandingView = new View()
smslandingView.init({
  SmsLanding,
})
